export default __webpack_public_path__ + "static/media/group-options-arrow-left.acd02785.svg";